/**
 * WordPress dependencies
 */
const { _x } = wp.i18n;

const ChakraIcons = {
	add: {
		label: _x( 'Add', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z" />
			</svg>
		),
	},
	atSign: {
		label: _x( 'At Sign', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M12,.5A11.634,11.634,0,0,0,.262,12,11.634,11.634,0,0,0,12,23.5a11.836,11.836,0,0,0,6.624-2,1.25,1.25,0,1,0-1.393-2.076A9.34,9.34,0,0,1,12,21a9.132,9.132,0,0,1-9.238-9A9.132,9.132,0,0,1,12,3a9.132,9.132,0,0,1,9.238,9v.891a1.943,1.943,0,0,1-3.884,0V12A5.355,5.355,0,1,0,12,17.261a5.376,5.376,0,0,0,3.861-1.634,4.438,4.438,0,0,0,7.877-2.736V12A11.634,11.634,0,0,0,12,.5Zm0,14.261A2.763,2.763,0,1,1,14.854,12,2.812,2.812,0,0,1,12,14.761Z" />
			</svg>
		),
	},
	attachment: {
		label: _x( 'Attachment', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M21.843,3.455a6.961,6.961,0,0,0-9.846,0L1.619,13.832a5.128,5.128,0,0,0,7.252,7.252L17.3,12.653A3.293,3.293,0,1,0,12.646,8L7.457,13.184A1,1,0,1,0,8.871,14.6L14.06,9.409a1.294,1.294,0,0,1,1.829,1.83L7.457,19.67a3.128,3.128,0,0,1-4.424-4.424L13.411,4.869a4.962,4.962,0,1,1,7.018,7.018L12.646,19.67a1,1,0,1,0,1.414,1.414L21.843,13.3a6.96,6.96,0,0,0,0-9.846Z" />
			</svg>
		),
	},
	bell: {
		label: _x( 'Bell', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
			</svg>
		),
	},
	calendar: {
		label: _x( 'Calendar', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 14 }
				width={ 14 }
				viewBox="0 0 14 14"
			>
				<path d="M10.8889,5.5 L3.11111,5.5 L3.11111,7.05556 L10.8889,7.05556 L10.8889,5.5 Z M12.4444,1.05556 L11.6667,1.05556 L11.6667,0 L10.1111,0 L10.1111,1.05556 L3.88889,1.05556 L3.88889,0 L2.33333,0 L2.33333,1.05556 L1.55556,1.05556 C0.692222,1.05556 0.00777777,1.75556 0.00777777,2.61111 L0,12.5 C0,13.3556 0.692222,14 1.55556,14 L12.4444,14 C13.3,14 14,13.3556 14,12.5 L14,2.61111 C14,1.75556 13.3,1.05556 12.4444,1.05556 Z M12.4444,12.5 L1.55556,12.5 L1.55556,3.94444 L12.4444,3.94444 L12.4444,12.5 Z M8.55556,8.61111 L3.11111,8.61111 L3.11111,10.1667 L8.55556,10.1667 L8.55556,8.61111 Z" />
			</svg>
		),
	},
	chat: {
		label: _x( 'Chat', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 14 }
				width={ 14 }
				viewBox="0 0 14 14"
			>
				<path d="M0.913134,0.920639 C1.49851,0.331726 2.29348,0 3.12342,0 L10.8766,0 C11.7065,0 12.5015,0.331725 13.0869,0.920639 C13.6721,1.50939 14,2.30689 14,3.13746 L14,8.12943 C13.9962,8.51443 13.9059,8.97125 13.7629,9.32852 C13.6128,9.683 13.3552,10.0709 13.0869,10.3462 C12.813,10.6163 12.4265,10.8761 12.0734,11.0274 C11.7172,11.1716 11.2607,11.263 10.8766,11.2669 L10.1234,11.2669 L10.1234,12.5676 L10.1209,12.5676 C10.1204,12.793 10.0633,13.0791 9.97807,13.262 C9.8627,13.466 9.61158,13.7198 9.40818,13.8382 L9.40824,13.8383 C9.4077,13.8386 9.40716,13.8388 9.40661,13.8391 C9.40621,13.8393 9.4058,13.8396 9.40539,13.8398 L9.40535,13.8397 C9.22958,13.9254 8.94505,13.9951 8.75059,14 L8.74789,14 C8.35724,13.9963 7.98473,13.8383 7.71035,13.5617 L5.39553,11.2669 L3.12342,11.2669 C2.29348,11.2669 1.49851,10.9352 0.913134,10.3462 C0.644826,10.0709 0.387187,9.683 0.23711,9.32852 C0.0941235,8.97125 0.00379528,8.51443 0,8.12943 L0,3.13746 C0,2.30689 0.327915,1.50939 0.913134,0.920639 Z M3.12342,1.59494 C2.71959,1.59494 2.33133,1.75628 2.04431,2.04503 C1.75713,2.33395 1.59494,2.72681 1.59494,3.13746 L1.59494,8.12943 C1.59114,8.35901 1.62114,8.51076 1.71193,8.72129 C1.79563,8.9346 1.88065,9.06264 2.04431,9.22185 C2.33133,9.5106 2.71959,9.67195 3.12342,9.67195 L5.72383,9.67195 C5.93413,9.67195 6.13592,9.75502 6.28527,9.90308 L8.52848,12.1269 L8.52848,10.4694 C8.52848,10.029 8.88552,9.67195 9.32595,9.67195 L10.8766,9.67195 C11.1034,9.67583 11.2517,9.64614 11.4599,9.55518 C11.6712,9.47132 11.7976,9.38635 11.9557,9.22185 C12.1193,9.06264 12.2044,8.9346 12.2881,8.72129 C12.3789,8.51076 12.4089,8.35901 12.4051,8.12943 L12.4051,3.13746 C12.4051,2.72681 12.2429,2.33394 11.9557,2.04503 C11.6687,1.75628 11.2804,1.59494 10.8766,1.59494 L3.12342,1.59494 Z" />
			</svg>
		),
	},
	check: {
		label: _x( 'Check', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 14 }
				width={ 14 }
				viewBox="0 0 14 14"
			>
				<g fill="currentColor">
					<polygon points="5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039" />
				</g>
			</svg>
		),
	},
	checkCircle: {
		label: _x( 'Check Circle', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z" />
			</svg>
		),
	},
	close: {
		label: _x( 'Close', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z" />
			</svg>
		),
	},
	copy: {
		label: _x( 'Copy', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
			</svg>
		),
	},
	delete: {
		label: _x( 'Delete', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M19.452 7.5H4.547a.5.5 0 00-.5.545l1.287 14.136A2 2 0 007.326 24h9.347a2 2 0 001.992-1.819L19.95 8.045a.5.5 0 00-.129-.382.5.5 0 00-.369-.163zm-9.2 13a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zm5 0a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zM22 4h-4.75a.25.25 0 01-.25-.25V2.5A2.5 2.5 0 0014.5 0h-5A2.5 2.5 0 007 2.5v1.25a.25.25 0 01-.25.25H2a1 1 0 000 2h20a1 1 0 000-2zM9 3.75V2.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v1.25a.25.25 0 01-.25.25h-5.5A.25.25 0 019 3.75z" />
			</svg>
		),
	},
	download: {
		label: _x( 'Download', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 14 }
				width={ 14 }
				viewBox="0 0 14 14"
			>
				<path d="M11.2857,6.05714 L10.08571,4.85714 L7.85714,7.14786 L7.85714,1 L6.14286,1 L6.14286,7.14786 L3.91429,4.85714 L2.71429,6.05714 L7,10.42857 L11.2857,6.05714 Z M1,11.2857 L1,13 L13,13 L13,11.2857 L1,11.2857 Z" />
			</svg>
		),
	},
	info: {
		label: _x( 'Info', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z" />
			</svg>
		),
	},
	infoOutline: {
		label: _x( 'Info Outline', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<g
					fill="currentColor"
					stroke="currentColor"
					strokeLinecap="square"
					strokeWidth="2"
				>
					<circle cx="12" cy="12" fill="none" r="11" stroke="currentColor" />
					<line fill="none" x1="11.959" x2="11.959" y1="11" y2="17" />
					<circle cx="11.959" cy="7" r="1" stroke="none" />
				</g>
			</svg>
		),
	},
	link: {
		label: _x( 'Link', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<g fill="currentColor">
					<path d="M10.458,18.374,7.721,21.11a2.853,2.853,0,0,1-3.942,0l-.892-.891a2.787,2.787,0,0,1,0-3.941l5.8-5.8a2.789,2.789,0,0,1,3.942,0l.893.892A1,1,0,0,0,14.94,9.952l-.893-.892a4.791,4.791,0,0,0-6.771,0l-5.8,5.8a4.787,4.787,0,0,0,0,6.77l.892.891a4.785,4.785,0,0,0,6.771,0l2.736-2.735a1,1,0,1,0-1.414-1.415Z" />
					<path d="M22.526,2.363l-.892-.892a4.8,4.8,0,0,0-6.77,0l-2.905,2.9a1,1,0,0,0,1.414,1.414l2.9-2.9a2.79,2.79,0,0,1,3.941,0l.893.893a2.786,2.786,0,0,1,0,3.942l-5.8,5.8a2.769,2.769,0,0,1-1.971.817h0a2.766,2.766,0,0,1-1.969-.816,1,1,0,1,0-1.415,1.412,4.751,4.751,0,0,0,3.384,1.4h0a4.752,4.752,0,0,0,3.385-1.4l5.8-5.8a4.786,4.786,0,0,0,0-6.771Z" />
				</g>
			</svg>
		),
	},
	lock: {
		label: _x( 'Lock', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5ZM7.75,6.75a4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5Z" />
			</svg>
		),
	},
	notAllowed: {
		label: _x( 'Not Allowed', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z" />
			</svg>
		),
	},
	question: {
		label: _x( 'Question', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z" />
			</svg>
		),
	},
	questionOutline: {
		label: _x( 'Question Outline', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<g stroke="currentColor" strokeWidth="1.5">
					<path
						strokeLinecap="round"
						fill="none"
						d="M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
					/>
					<path
						fill="none"
						strokeLinecap="round"
						d="M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
					/>
					<circle fill="none" strokeMiterlimit="10" cx="12" cy="12" r="11.25" />
				</g>
			</svg>
		),
	},
	settings: {
		label: _x( 'Settings', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 14 }
				width={ 14 }
				viewBox="0 0 14 14"
			>
				<path d="M14,7.77 L14,6.17 L12.06,5.53 L11.61,4.44 L12.49,2.6 L11.36,1.47 L9.55,2.38 L8.46,1.93 L7.77,0.01 L6.17,0.01 L5.54,1.95 L4.43,2.4 L2.59,1.52 L1.46,2.65 L2.37,4.46 L1.92,5.55 L0,6.23 L0,7.82 L1.94,8.46 L2.39,9.55 L1.51,11.39 L2.64,12.52 L4.45,11.61 L5.54,12.06 L6.23,13.98 L7.82,13.98 L8.45,12.04 L9.56,11.59 L11.4,12.47 L12.53,11.34 L11.61,9.53 L12.08,8.44 L14,7.75 L14,7.77 Z M7,10 C5.34,10 4,8.66 4,7 C4,5.34 5.34,4 7,4 C8.66,4 10,5.34 10,7 C10,8.66 8.66,10 7,10 Z" />
			</svg>
		),
	},
	star: {
		label: _x( 'Star', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M23.555,8.729a1.505,1.505,0,0,0-1.406-.98H16.062a.5.5,0,0,1-.472-.334L13.405,1.222a1.5,1.5,0,0,0-2.81,0l-.005.016L8.41,7.415a.5.5,0,0,1-.471.334H1.85A1.5,1.5,0,0,0,.887,10.4l5.184,4.3a.5.5,0,0,1,.155.543L4.048,21.774a1.5,1.5,0,0,0,2.31,1.684l5.346-3.92a.5.5,0,0,1,.591,0l5.344,3.919a1.5,1.5,0,0,0,2.312-1.683l-2.178-6.535a.5.5,0,0,1,.155-.543l5.194-4.306A1.5,1.5,0,0,0,23.555,8.729Z" />
			</svg>
		),
	},
	time: {
		label: _x( 'Time', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<g fill="currentColor">
					<path d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z" />
					<path d="M17.134,15.81,12.5,11.561V6.5a1,1,0,0,0-2,0V12a1,1,0,0,0,.324.738l4.959,4.545a1.01,1.01,0,0,0,1.413-.061A1,1,0,0,0,17.134,15.81Z" />
				</g>
			</svg>
		),
	},
	unlock: {
		label: _x( 'Unlock', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M19.5,9.5h-.75V6.75A6.751,6.751,0,0,0,5.533,4.811a1.25,1.25,0,1,0,2.395.717A4.251,4.251,0,0,1,16.25,6.75V9a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5Z" />
			</svg>
		),
	},
	view: {
		label: _x( 'View', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<g fill="currentColor">
					<path d="M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z" />
					<circle cx="12" cy="12" r="2" />
				</g>
			</svg>
		),
	},
	viewOff: {
		label: _x( 'View Off', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<g fill="currentColor">
					<path d="M23.2,10.549a20.954,20.954,0,0,0-4.3-3.6l4-3.995a1,1,0,1,0-1.414-1.414l-.018.018a.737.737,0,0,1-.173.291l-19.5,19.5c-.008.007-.018.009-.026.017a1,1,0,0,0,1.631,1.088l4.146-4.146a11.26,11.26,0,0,0,4.31.939h.3c4.256,0,8.489-2.984,11.051-5.8A2.171,2.171,0,0,0,23.2,10.549ZM16.313,13.27a4.581,4.581,0,0,1-3,3.028,4.3,4.3,0,0,1-3.1-.19.253.253,0,0,1-.068-.407l5.56-5.559a.252.252,0,0,1,.407.067A4.3,4.3,0,0,1,16.313,13.27Z" />
					<path d="M7.615,13.4a.244.244,0,0,0,.061-.24A4.315,4.315,0,0,1,7.5,12,4.5,4.5,0,0,1,12,7.5a4.276,4.276,0,0,1,1.16.173.244.244,0,0,0,.24-.062l1.941-1.942a.254.254,0,0,0-.1-.421A10.413,10.413,0,0,0,12,4.75C7.7,4.692,3.4,7.7.813,10.549a2.15,2.15,0,0,0-.007,2.9,21.209,21.209,0,0,0,3.438,3.03.256.256,0,0,0,.326-.029Z" />
				</g>
			</svg>
		),
	},
	warning: {
		label: _x( 'Warning', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z" />
			</svg>
		),
	},
	warningTwo: {
		label: _x( 'Warning Two', 'label', 'alerts-dlx' ),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height={ 24 }
				width={ 24 }
				viewBox="0 0 24 24"
			>
				<path d="M23.119,20,13.772,2.15h0a2,2,0,0,0-3.543,0L.881,20a2,2,0,0,0,1.772,2.928H21.347A2,2,0,0,0,23.119,20ZM11,8.423a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Zm1.05,11.51h-.028a1.528,1.528,0,0,1-1.522-1.47,1.476,1.476,0,0,1,1.448-1.53h.028A1.527,1.527,0,0,1,13.5,18.4,1.475,1.475,0,0,1,12.05,19.933Z" />
			</svg>
		),
	},
};

export default ChakraIcons;
